import {
  deleteDoc,
  doc,
  getDoc,
  setDoc,
  writeBatch
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { initialData } from "../data/initialData";
import type { Category, MediaAsset, MenuItem, Restaurant } from "../types";
import { db, isFirebaseConfigured, storage } from "./firebase";

function requireDb() {
  if (!isFirebaseConfigured || !db) {
    throw new Error("Firebase ist nicht konfiguriert.");
  }
  return db;
}

export async function isAdminUser(uid: string): Promise<boolean> {
  const firestore = requireDb();
  const snapshot = await getDoc(doc(firestore, "adminUsers", uid));
  return snapshot.exists() && snapshot.data().active === true;
}

export async function saveRestaurant(restaurant: Restaurant): Promise<void> {
  await setDoc(doc(requireDb(), "restaurants", "ortaya"), restaurant);
}

export async function saveCategory(category: Category): Promise<void> {
  await setDoc(doc(requireDb(), "categories", category.id), category);
}

export async function deleteCategory(id: string): Promise<void> {
  await deleteDoc(doc(requireDb(), "categories", id));
}

export async function saveMenuItem(item: MenuItem): Promise<void> {
  await setDoc(doc(requireDb(), "menuItems", item.id), item);
}

export async function deleteMenuItem(id: string): Promise<void> {
  await deleteDoc(doc(requireDb(), "menuItems", id));
}

export async function saveMedia(asset: MediaAsset): Promise<void> {
  await setDoc(doc(requireDb(), "media", asset.id), asset);
}

export async function deleteMedia(id: string): Promise<void> {
  await deleteDoc(doc(requireDb(), "media", id));
}

export async function uploadMediaFile(file: File): Promise<string> {
  if (!storage) {
    throw new Error("Firebase Storage ist nicht konfiguriert.");
  }
  const path = `media/${Date.now()}-${file.name.replace(/[^a-zA-Z0-9._-]/g, "-")}`;
  const uploaded = await uploadBytes(ref(storage, path), file, { contentType: file.type });
  return getDownloadURL(uploaded.ref);
}

export async function publishInitialCatalog(): Promise<void> {
  const firestore = requireDb();
  const writes = [
    { collection: "restaurants", id: "ortaya", data: initialData.restaurant },
    ...initialData.categories.map((data) => ({ collection: "categories", id: data.id, data })),
    ...initialData.menuItems.map((data) => ({ collection: "menuItems", id: data.id, data })),
    ...initialData.media.map((data) => ({ collection: "media", id: data.id, data }))
  ];

  for (let start = 0; start < writes.length; start += 400) {
    const batch = writeBatch(firestore);
    for (const write of writes.slice(start, start + 400)) {
      batch.set(doc(firestore, write.collection, write.id), write.data);
    }
    await batch.commit();
  }
}
